// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Mn4W","modalForm":"UpgradeEpcsModal_modalForm__39qNt","modalFooter":"UpgradeEpcsModal_modalFooter__pDvw_"};